import React, { useState, memo  } from 'react'

import TreeGroupNode from './TreeGroupNode'
import TreeVehicleNode from './TrackTrace/TreeVehicleNode'

import './TreeVehicles.sass'

const TreeVehicles = (props) => {
	const { deviceGroups, activeTreeItem, onTreeDeviceClick, onTreeGroupNodeClick } = props
	const sortFunc = (values) => {
		if (navigator && navigator.userAgent.search("Firefox") > -1) {
			return _.orderBy(values, ['online', 'vehicle_name', 'device_id'], ['desc', 'asc', 'asc']).sort((a, b) => (((a.online && a.online.state) && (b.online && b.online.state)) && ((a.ignition && a.ignition.state) < (b.ignition && b.ignition.state))) ? 1 : -1);
		}
		return _.orderBy(values, ['online', 'vehicle_name', 'device_id'], ['desc', 'asc', 'asc']).sort((a, b) => (((a.online && a.online.state) && (b.online && b.online.state)) && ((a.ignition && a.ignition.state) && (!b.ignition || !b.ignition.state))) ? -1 : 1);
	}
	const renderTree = () => {
		const res = []
		deviceGroups.forEach((group, i) => {
			res.push(
				<TreeGroupNode
					key={group.groupName}
					group={group}
					onTreeGroupNodeClick={onTreeGroupNodeClick}
				/>
			)

			if (!group.collapsed) {
				// TODO: maybe make sense to do sorting before storing groups in Dashboard
				// BUT the /devices/eventupdates API updates the devices list and status can be changed after group sorting
				sortFunc(group.devices).map((device) => {
					res.push(
						<TreeVehicleNode
							key={device.vehiclesType === 'equipment' ? device.beacon_id : device.device_id}
							device={device}
							activeTreeItem={activeTreeItem}
							onTreeDeviceClick={onTreeDeviceClick}
						/>
					)
				})
			}
		})

		return res
	}

	return (
		<div className="devices-tree" style={{ height: `calc(100vh - 404px)` }}>
			{renderTree()}
		</div>
	)
}

export default memo(TreeVehicles);
